<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength=255
        />

        <input-rich-text
            name="description"
            label="Description"
            class="mt-3"
            v-model="form.description"
            :error="errors.description ? errors.description[0] : null"
            :language="form.language"
        />

        <input-text
            name="total_time_name"
            label="Total Time Name"
            class="mt-3"
            v-model="form.total_time_name"
            :error="errors.total_time_name ? errors.total_time_name[0] : null"
            :maxlength=255
        />

        <input-time
            name="total_time_value"
            label="Total Time Value"
            class="mt-3"
            v-model="form.total_time_value"
            :error="errors.total_time_value ? errors.total_time_value[0] : null"
        />

        <input-text
            name="supply_name"
            label="Supply Name"
            class="mt-3"
            v-model="form.supply_name"
            :error="errors.supply_name ? errors.supply_name[0] : null"
            :maxlength=255
        />

        <input-text
            name="supply_value"
            label="Supply Value"
            class="mt-3"
            v-model="form.supply_value"
            :error="errors.supply_value ? errors.supply_value[0] : null"
            :maxlength=255
        />

        <input-text
            name="tool_name"
            label="Tool Name"
            class="mt-3"
            v-model="form.tool_name"
            :error="errors.tool_name ? errors.tool_name[0] : null"
            :maxlength=255
        />

        <input-text
            name="tool_value"
            label="Tool Value"
            class="mt-3"
            v-model="form.tool_value"
            :error="errors.tool_value ? errors.tool_value[0] : null"
            :maxlength=255
        />

        <how-to-steps
            class="mt-3"
            v-model="form.steps"
            :errors="errors"
            :language="form.language"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "HowToForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                description: this.getFormData("description"),
                total_time_name: this.getFormData("total_time_name"),
                total_time_value: this.getFormData("total_time_value"),
                supply_name: this.getFormData("supply_name"),
                supply_value: this.getFormData("supply_value"),
                tool_name: this.getFormData("tool_name"),
                tool_value: this.getFormData("tool_value"),
                steps: this.getFormData("steps", []),
            },
        };
    },
};
</script>
